export default __webpack_public_path__ + "static/media/sdp-logo-full.7a772d5a.svg";